// extracted by mini-css-extract-plugin
export var borderRadius = "_er-4";
export var large = "_er-3";
export var logoContainer = "_er-0";
export var nameLogo = "_er-2";
export var small = "_er-1";